<template>
  <div :class="classes">
    <v-chip-group mandatory v-click-outside="{ handler: onClickOutside, include: getOutsideIncludes }" active-class="primary--text">
      <v-chip ref="chip" v-for="(group, idx) in chipGroups" :key="idx">
        <v-menu close-on-click offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small tile ref="button" v-bind="attrs" v-on="on" @click="selectGroup(idx)">
              <v-icon small>{{ groupIcon(idx, group) }}</v-icon>
              <span>{{ group.name }}</span>
            </v-btn>
          </template>
          <v-list v-show="showMenu" :value="idx" dense>
            <v-list-item class="group-menu" v-for="(item, index) in group.children" :key="index" @click="selectMenu(index, item)">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NodePath from '@/utils/node-path';
import bus from '@/utils/bus';

export default {
  data() {
    return {
      selectedGroupIndex: 0,
      chipGroups: [],
      path: [],
      showMenu: true,
      nodePath: null,
      interval: null,
    };
  },
  computed: {
    ...mapState('common/system', ['system']),
    ...mapState('common/group', ['groups']),
    ...mapState('common/user', ['defaultTargetMonitoringSystemId']),
    classes() {
      return {
        'hidden-group-selector': this.$route.meta.hiddenGroupSelector || false,
        'float-left': true,
        'd-inline-block': true,
        'menu-bar-left': true,
        'group-chip': true,
      };
    },
  },
  watch: {
    $route: {
      handler: 'onChangeRouteHander',
    },
  },
  methods: {
    onChangeRouteHander() {
      this.chipGroups = [];
      this.chipGroups.push({
        name: 'Group',
        children: this.groups,
      });
      this.interval = setInterval(() => {
        if (this.chipGroups.length == this.$refs.button.length) {
          clearInterval(this.interval);
          this.selectedGroupIndex = this.chipGroups.length - 1;
          this.showMenu = (this.chipGroups[this.selectedGroupIndex].children || []).length > 0;
          this.$refs.chip[this.selectedGroupIndex].click();
          this.path = this.nodePath.findPath(this.chipGroups[this.selectedGroupIndex], this.groups).group;
        }
      }, 30);
      const systemId = this.$route.params.systemId || this.defaultTargetMonitoringSystemId;
      if (this.system.id != systemId) this.$store.dispatch('common/system/setSystem', systemId);
      this.nodePath = new NodePath(this.groups, { key: 'systemId', value: systemId }).find().computeFirstNode();
      this.nodePath.firstNode.path.group.map(item => this.chipGroups.push(item));
    },
    selectMenu(index, item) {
      this.chipGroups.slice(this.selectedGroupIndex + 1).forEach(() => {
        const targetIndex = this.selectedGroupIndex + 1;
        this.chipGroups.splice(targetIndex, 1);
      });
      this.addGroup(item);
    },
    addGroup(group) {
      this.chipGroups.push(group);
      this.interval = setInterval(() => {
        if (this.chipGroups.length == this.$refs.button.length) {
          clearInterval(this.interval);
          this.selectGroup(this.chipGroups.length - 1);
        }
      }, 30);
    },
    async selectGroup(index) {
      this.selectedGroupIndex = index;
      this.showMenu = (this.chipGroups[index].children || []).length > 0;
      this.$refs.chip[index].click();
      // 최종으로 systemId 를 선택했을 경우
      if (this.chipGroups[index].systemId) {
        this.path = this.nodePath.findPath(this.chipGroups[index], this.groups).group;
        /*
         * Commented.by.KWShin.2024.02.14.
         * systemId 가 변경되었을 경우
         * route와 system 정보 변경을 위한 행위를 Gnb.vue 에게 위임하기 위해 bus에 이벤트를 발생시킨다.
         */
        if (this.system.id != this.chipGroups[index].systemId) {
          bus.$emit('change:group-selector-systemId', {
            systemId: this.chipGroups[index].systemId,
            beforeSystemId: this.system.id,
          });
        }
      }
    },
    setGroupPath() {
      this.chipGroups = [];
      this.addGroup({
        name: 'Group',
        children: this.groups,
      });
      // 기존 선택된 경로의 그룹 정보가 있을 경우
      if (this.path.length) {
        this.path.forEach(item => this.chipGroups.push(item));
      }
      // 없을 경우 node-path 를 순회하여 초기 그룹 정보 세팅
      else {
        const systemId = this.$route.params.systemId || this.defaultTargetMonitoringSystemId;
        this.nodePath = new NodePath(this.groups, { key: 'systemId', value: systemId }).find().computeFirstNode();
        this.nodePath.firstNode?.path?.group.map(item => this.chipGroups.push(item));
      }
    },
    groupIcon(index, group) {
      if (index == 0) return 'mdi-sitemap';
      else if (group.systemId) return 'mdi-application';
      else return 'mdi-chevron-double-right';
    },
    onClickOutside() {
      const lastIndex = this.chipGroups.length - 1;
      if (!this.chipGroups[lastIndex].systemId) {
        this.setGroupPath();
      }
    },
    getOutsideIncludes() {
      return Array.from(document.querySelectorAll('.group-menu'));
    },
  },
  created() {
    this.setGroupPath();
  },
};
</script>

<style>
.menu-bar-left {
  display: inline-block;
  width: 30%;
  position: absolute;
  height: 30px;
}
.menu-bar-left .v-breadcrumbs {
  padding: 0;
}
.menu-bar-left .v-breadcrumbs .v-breadcrumbs__divider {
  padding: 0;
}

.v-application p {
  margin-bottom: 0px;
}
.v-chip.v-size--small {
  border-radius: 5px;
}
.v-slide-group__prev,
.v-slide-group__prev--disabled {
  display: flex !important;
  min-width: 41px;
}
.v-slide-group__next,
.v-slide-group__next--disabled {
  display: flex !important;
  min-width: 41px;
}
</style>

<style scoped>
.group-chip .v-chip {
  border-radius: initial;
  margin: 0px;
  padding: 0px;
  height: 33px;
  background: none;
}
.hidden-group-selector {
  display: none !important;
}
</style>
